import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BuscarPropriedadePageRoutingModule } from './buscar-propriedade-routing.module';

import { BuscarPropriedadePage } from './buscar-propriedade.page';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMaskModule } from 'ngx-mask';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  imports: [
    MatAutocompleteModule,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskModule.forRoot(),
    BuscarPropriedadePageRoutingModule
  ],
  declarations: [BuscarPropriedadePage]
})
export class BuscarPropriedadePageModule {}
